var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M60 30.675C60 28.7 59.8212 26.825 59.5147 25H30.6514V36.275H47.1775C46.4368 39.975 44.2657 43.1 41.0473 45.225V52.725H50.9068C56.6795 47.5 60 39.8 60 30.675V30.675Z",
    fill: "#4285F4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.6512 60C38.9271 60 45.8492 57.3 50.9067 52.725L41.0472 45.225C38.2885 47.025 34.7892 48.125 30.6512 48.125C22.6564 48.125 15.8875 42.85 13.461 35.725H3.29492V43.45C8.32685 53.25 18.6717 60 30.6512 60V60Z",
    fill: "#34A853"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.461 35.725C12.8225 33.925 12.4904 32 12.4904 30C12.4904 28 12.848 26.0751 13.461 24.275V16.55H3.29502C1.20051 20.6 0 25.15 0 30C0 34.85 1.20051 39.4 3.29502 43.45L13.461 35.725Z",
    fill: "#FBBC05"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M30.6512 11.875C35.1723 11.875 39.2081 13.4 42.4009 16.375L51.1366 7.825C45.8492 2.975 38.9271 0 30.6512 0C18.6717 0 8.32685 6.75001 3.29492 16.55L13.461 24.275C15.8875 17.15 22.6564 11.875 30.6512 11.875V11.875Z",
    fill: "#EA4335"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.1ded275549364ebff9a22acf26ca1147.svg";
export { ForwardRef as ReactComponent };